import { Coords, Device, DeviceVariable, Service } from '../../domain/streamer_box';
import { BaseAPIClient } from '../base-api-client';

export const StreamerBoxAPI = {
  fetchDevices(this: BaseAPIClient): Promise<readonly Device[]> {
    return this.get('/streamer-box/devices');
  },

  fetchDevice(this: BaseAPIClient, deviceId: number): Promise<Device> {
    return this.get(`/streamer-box/devices/${deviceId}`);
  },

  restartDevice(this: BaseAPIClient, deviceId: number): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/reboot`);
  },

  renameDevice(this: BaseAPIClient, deviceId: number, name: string): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/rename`, {
      name,
    });
  },

  setDeviceCoords(this: BaseAPIClient, deviceId: number, { lat, lng }: Coords): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/set-coords`, {
      latitude: lat,
      longitude: lng,
    });
  },

  fetchVariables(this: BaseAPIClient, deviceId: number): Promise<readonly DeviceVariable[]> {
    return this.get(`/streamer-box/devices/${deviceId}/vars`);
  },

  updateVariables(
    this: BaseAPIClient,
    deviceId: number,
    vars: readonly DeviceVariable[],
  ): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/vars`, vars);
  },

  fetchServices(this: BaseAPIClient, deviceId: number): Promise<readonly Service[]> {
    return this.get(`/streamer-box/devices/${deviceId}/services`);
  },

  startService(this: BaseAPIClient, deviceId: number, imageId: number): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/services/${imageId}/start`);
  },

  restartService(this: BaseAPIClient, deviceId: number, imageId: number): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/services/${imageId}/restart`);
  },

  stopService(this: BaseAPIClient, deviceId: number, imageId: number): Promise<void> {
    return this.post(`/streamer-box/devices/${deviceId}/services/${imageId}/stop`);
  },
};
